import { createAction } from '@reduxjs/toolkit';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import { initialValue } from '../../helperContext';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const updateBaseline = createAction(
  BaselineAffectationType.UpdateBaseline,
  (baseLineOrderWorkunit: OrderWorkunit | Partial<OrderWorkunit>) => ({
    payload: { baseLineOrderWorkunit },
  })
);
export const bulkUpdateBaselineAction = createAction(
  BaselineAffectationType.BulkUpdateBaseline,
  (change: Partial<OrderWorkunit>) => ({
    payload: change,
  })
);

export default (state = initialValue, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.UpdateBaseline:
      return {
        ...state,
        baseLineOrderWorkunits: state.baseLineOrderWorkunits.map((ow) =>
          ow.id !== action.payload.baseLineOrderWorkunit?.id ? ow : { ...ow, ...action.payload.baseLineOrderWorkunit }
        ),
      };
    case BaselineAffectationType.BulkUpdateBaseline:
      return {
        ...state,
        baseLineOrderWorkunits: updateBulkBaseline(state.baseLineOrderWorkunits, state.selectedItems, action.payload),
      };
    default:
      return state;
  }
};

function updateBulkBaseline(
  baselinebaseline: OrderWorkunit[],
  selectedItems: OrderWorkunit['id'][],
  changes: Partial<OrderWorkunit>
) {
  return baselinebaseline.map((owu) => {
    const isBaselineInListToBeUpdated = selectedItems.findIndex((s) => s === owu.id);
    if (isBaselineInListToBeUpdated === -1) return owu;
    return { ...owu, ...changes };
  });
}
